module.exports = __webpack_public_path__ + "static/media/Discovery-Experience.6c1e5623.svg";